'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = require('react-css-themr');

var _identifiers = require('../../identifiers');

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Text = function (_React$Component) {
  _inherits(Text, _React$Component);

  function Text() {
    _classCallCheck(this, Text);

    return _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
  }

  _createClass(Text, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          asSpan = _props.asSpan;

      if (asSpan) {
        return _react2['default'].createElement('span', _extends({
          className: this.textClass
        }, this.additionalProps), children);
      }

      return _react2['default'].createElement('p', _extends({
        className: this.textClass
      }, this.additionalProps), children);
    }
  }, {
    key: 'textClass',
    get: function get() {
      var _classNames;

      var _props2 = this.props,
          theme = _props2.theme,
          size = _props2.size,
          color = _props2.color,
          align = _props2.align,
          weight = _props2.weight,
          italic = _props2.italic,
          underlined = _props2.underlined,
          nowrap = _props2.nowrap,
          inline = _props2.inline,
          spaced = _props2.spaced,
          uppercase = _props2.uppercase,
          lowercase = _props2.lowercase,
          capitalize = _props2.capitalize,
          className = _props2.className;
      return (0, _classnames2['default'])(theme.text, theme[size], theme[align], theme[color], theme[weight], (_classNames = {}, _defineProperty(_classNames, theme.italic, italic), _defineProperty(_classNames, theme.underlined, underlined), _defineProperty(_classNames, theme.nowrap, nowrap), _defineProperty(_classNames, theme.inline, inline), _defineProperty(_classNames, theme.spaced, spaced), _defineProperty(_classNames, theme.uppercase, uppercase), _defineProperty(_classNames, theme.lowercase, lowercase), _defineProperty(_classNames, theme.capitalize, capitalize), _classNames), className);
    }
  }, {
    key: 'additionalProps',
    get: function get() {
      return (0, _omit2['default'])(this.props, ['theme', 'size', 'color', 'align', 'weight', 'italic', 'underlined', 'nowrap', 'inline', 'spaced', 'uppercase', 'lowercase', 'capitalize', 'className', 'asSpan']);
    }
  }]);

  return Text;
}(_react2['default'].Component);

Text.themeShape = {
  text: _propTypes2['default'].string.isRequired,
  title1: _propTypes2['default'].string.isRequired,
  title2: _propTypes2['default'].string.isRequired,
  large: _propTypes2['default'].string.isRequired,
  regular: _propTypes2['default'].string.isRequired,
  small: _propTypes2['default'].string.isRequired,
  tiny: _propTypes2['default'].string.isRequired,
  primary: _propTypes2['default'].string.isRequired,
  success: _propTypes2['default'].string.isRequired,
  warning: _propTypes2['default'].string.isRequired,
  danger: _propTypes2['default'].string.isRequired,
  black: _propTypes2['default'].string.isRequired,
  white: _propTypes2['default'].string.isRequired,
  grey: _propTypes2['default'].string.isRequired,
  none: _propTypes2['default'].string.isRequired,
  left: _propTypes2['default'].string.isRequired,
  center: _propTypes2['default'].string.isRequired,
  right: _propTypes2['default'].string.isRequired,
  justified: _propTypes2['default'].string.isRequired,
  bold: _propTypes2['default'].string.isRequired,
  light: _propTypes2['default'].string.isRequired,
  thin: _propTypes2['default'].string.isRequired,
  normal: _propTypes2['default'].string.isRequired,
  underlined: _propTypes2['default'].string.isRequired,
  italic: _propTypes2['default'].string.isRequired,
  nowrap: _propTypes2['default'].string.isRequired,
  inline: _propTypes2['default'].string.isRequired,
  spaced: _propTypes2['default'].string.isRequired,
  uppercase: _propTypes2['default'].string.isRequired,
  lowercase: _propTypes2['default'].string.isRequired,
  capitalize: _propTypes2['default'].string.isRequired
};
Text.propTypes = {
  children: _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(_propTypes2['default'].node), _propTypes2['default'].node]),
  theme: _propTypes2['default'].shape(Text.themeShape).isRequired,
  size: _propTypes2['default'].oneOf(['title1', 'title2', 'large', 'regular', 'small', 'tiny']),
  color: _propTypes2['default'].oneOf(['success', 'warning', 'danger', 'grey', 'white', 'black', 'primary', 'none']),
  weight: _propTypes2['default'].oneOf(['bold', 'medium', 'light', 'thin', 'normal']),
  align: _propTypes2['default'].oneOf(['left', 'center', 'right', 'justified']),
  italic: _propTypes2['default'].bool,
  underlined: _propTypes2['default'].bool,
  nowrap: _propTypes2['default'].bool,
  inline: _propTypes2['default'].bool,
  spaced: _propTypes2['default'].bool,
  uppercase: _propTypes2['default'].bool,
  lowercase: _propTypes2['default'].bool,
  capitalize: _propTypes2['default'].bool,
  asSpan: _propTypes2['default'].bool,
  className: _propTypes2['default'].string
};
Text.defaultProps = {
  weight: 'medium',
  size: 'small',
  asSpan: false
};
exports['default'] = (0, _reactCssThemr.themr)(_identifiers.TEXT)(Text);
exports.Text = Text;